import axios from '@/utils/axios';
import vendorAxios from 'axios';

const getClientIp = async () => {
	try {
		const { data } = await vendorAxios.get('https://api.ipify.org?format=json');

		return data.ip;

	} catch (error) {
		console.error(error);
		//Intentionally swallowing error so we default to local IP Address
		return "127.0.0.1";
	}
};

const updateClientAuditAsync = async (request) => {
	try {
		const { data } = await axios.post(`${process.env.BASE_URL}api/Audit/Client`, request);

		return data;
	} catch (error) {
		if (typeof error === 'string') {
			throw new Error(error);
		}
		throw error;
	}
};

export default {
	updateClientAuditAsync, getClientIp
};

export { updateClientAuditAsync, getClientIp };
